import { API, Auth } from "aws-amplify";
// import config from "../config.json";
import { OffLineAPI } from "../offline-auth/api";
import { encryptData } from "../lib/crypto";
let _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;

let schpromise;
let slotspromise;
// let slotpromise;
let disdatepromise;
let pastmeetpromise;
let getPrespromise;
let inviteespromise;

export async function createSchedule(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/schedule?query=${token}`, { body });
}

export async function updateSchedule(body, id) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put("schedule", `/schedule?id=${id}&query=${token}`, { body });
}
export function getRecordingsById(id) {
    
    // return _API.get("schedule", `/getRecordingSpace?clinicId=${id}`);
    return _API.get("schedule", `/getrecordings?appointmentId=${id}`);
    
}

export async function getSchedules() {
    if (schpromise) {
        _API.cancel(schpromise, "MY cancelation");
    }
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    schpromise = _API.get("schedule", `/schedule?query=${token}`);
    return schpromise;
}

export function sendPrescription(apptid) {
    return _API.get("schedule", `/sendprescription?appointmentId=${apptid}`);
}

export async function deleteSchedule(id) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del("schedule", `/deleteschedule?id=${id}&query=${token}`, {});
}

export async function confirmDeleteSchedule(id) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.get("schedule", `/confirmdeletesche?id=${id}&query=${token}`, {});
}
export function deleteGroupSchedule(from, to) {
    return _API.del("schedule", `/schedule?from=${from}&to=${to}`);
}

export async function deleteAllSch() {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del("schedule", `/deleteall?query=${token}`);
}

export async function createSlot(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/slots?query=${token}`, { body });
}

export async function updateSlot(body, id) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put("schedule", `/slots?id=${id}&query=${token}`, { body });
}

export async function getSolts(id) {
    if (slotspromise) {
        _API.cancel(slotspromise, "MY cancelation");
    }
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    slotspromise = _API.get("schedule", `/slots?id=${id}&query=${token}`);
    return slotspromise;
}

// export async function getSolt(id) {
//     if (slotpromise) {
//         _API.cancel(slotpromise, "MY cancelation");
//     }
//     const session = await Auth.currentSession();
//     let token = session.getAccessToken().getJwtToken();
//     slotpromise = _API.get("schedule", `/slots?slotId=${id}&query=${token}`);
//     return slotpromise;
// }

export async function deleteSolt(id) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del("schedule", `/slots?id=${id}&query=${token}`);
}

export async function getDisableDates(id = null) {
    if (disdatepromise) {
        _API.cancel(disdatepromise, "MY cancelation");
    }
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    let url = id !== null ? `/disabledates?userId=${id}&query=${token}` : `/disabledates?query=${token}`;
    disdatepromise = _API.get("schedule", url);
    return disdatepromise;
}

export async function saveDisableDates(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/disabledates?query=${token}`, { body });
}

export async function changeApptStatus(id, status, paymentIntentId = undefined, clinicId = undefined, refundRequested = undefined) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    let body = {
        id,
        status,
        paymentIntentId,
        clinicId,
        refundRequested,
        mode: "inApi",
    };
    return _API.put("schedule", `/appointment-status?query=${token}`, { body });
}

// export async function createSessionInAPi(appointmentId) {
//     const session = await Auth.currentSession();
//     let token = session.getAccessToken().getJwtToken();
//     let body = {
//         query: token,
//         appointmentId: appointmentId,
//     };
//     return _API.post("schedule", `/createsession`, { body });
// }
export async function createDoctorFiles(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/waitingroomupload?query=${token}`, { body });
}
export function createPrescription(body) {
    return _API.post("schedule", `/prescription`, { body });
}
export function getPrescription(id) {
    if(getPrespromise){
        _API.cancel(getPrespromise, "MY cancelation");  
    }
    getPrespromise = _API.get("schedule", `/prescription?appointmentId=${id}`);
    return getPrespromise;
}
export function updatePrescription(id, body) {
    return _API.put("schedule", `/prescription/${id}`, { body });
}
export function deletePrescription(body) {
    return _API.del("schedule", `/prescription`, { body });
}
export function createInvitee(body, sub) {
    let realSub = sub ? sub : localStorage.getItem("sub");
    return _API.post("schedule", `/invitees?sub=${realSub}`, { body });
}
export function getInvitees(query) {
    if(inviteespromise){
        _API.cancel(inviteespromise, "MY cancelation")  
    }
    inviteespromise = _API.get("schedule", `/invitees${query}`);
    return inviteespromise;
}
export function deleteInvitee(body) {
    return _API.del("schedule", `/invitees?sub=${localStorage.getItem("sub")}`, { body });
}
export async function updateDoctorSignature(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/doctorsign?query=${token}`, { body });
}

export async function deleteSignature(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del("schedule", `/doctorsign?query=${token}`, { body });
}

export async function deletedocSignature(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("schedule", `/deletedocsign?query=${token}`, { body });
}

export function deleteInvitees(bd, _id) {
    const newBody = {
        email: bd.email,
        _id: _id,
        sub: localStorage.getItem("sub"),
    };
    return _API.post("schedule", `/deleteinvitees`, { body: { body: encryptData(newBody) } });
}

export function prescriptiondelete(body) {
    return _API.post("schedule", `/deleteprescription`, { body });
}

export function getPastMeetings(sessionId, scheduleId) {
    if (pastmeetpromise) {
        _API.cancel(pastmeetpromise, "MY cancelation");
    }
    const config = {
        headers: {
            Authorization: `Bearer ${scheduleId}`,
            "Content-Type": "application/json",
        },
    };

    pastmeetpromise = API.get("inApiPublic", `/getsessionlogs?sessionId=${sessionId}`, config);
    return pastmeetpromise;
}
